<!--
  Avatar.vue

  Small circular initials avatar used in the Stores list owner column,
  the Team & Permissions roster, and anywhere a roster entry appears.

  - kind="owner" uses the ThreadFlow secondary (navy) background.
  - kind="builder" (default) uses primary-soft on primary.
-->
<template>
    <div
        class="dist-avatar"
        :class="`dist-avatar--${kind}`"
        :title="name || initialsResolved"
        data-testid="dist-avatar"
    >
        {{ initialsResolved }}
    </div>
</template>

<script>
function initialsFromName(name) {
    if (!name) return "?";
    const parts = String(name).trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default {
    name: "Avatar",
    props: {
        name: { type: String, default: "" },
        initials: { type: String, default: "" },
        kind: {
            type: String,
            default: "builder",
            validator: (v) => ["owner", "builder"].includes(v),
        },
    },
    computed: {
        initialsResolved() {
            return this.initials || initialsFromName(this.name);
        },
    },
};
</script>

<style scoped>
.dist-avatar {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Poppins", sans-serif;
    font-size: 10px;
    font-weight: 600;
    flex-shrink: 0;
    user-select: none;
}
.dist-avatar--owner {
    background: var(--tf-secondary);
    color: var(--tf-bg);
}
.dist-avatar--builder {
    background: var(--tf-primary-soft);
    color: var(--tf-primary);
}
</style>
